function initFooterMap() {
    var footerMap = $('#footer-map');

    if (footerMap.length < 1) {
        return null;
    }

    var position = {
        lat: footerMap.data('lat'),
        lng:  footerMap.data('lng')
    };

    // Styles a map in night mode.
    var map = new google.maps.Map(document.getElementById('footer-map'), {
        center: position,
        zoom: 16,
        styles: mapStyles
    });

    var marker = new google.maps.Marker({
        position: position,
        map: map,
        icon: 'https://sanus.cz/www/images/marker.svg',
        label:
            {
                color: '#00aaff',
                fontWeight: 'bold',
                fontSize: '14px',
                padding: '10px',
                marginLeft: '50px',
                text: ' '
            }
    });

    var infowindow = new google.maps.InfoWindow({
        content: footerMap.data('address')
    });

    infowindow.open(map, marker);
}